import { Field, ErrorMessage } from 'formik'
import Postcode from 'Shared/components/Postcode/Postcode'
import { FIELD_CONFIGS } from './fieldConfig'
import './EditItem.scoped.scss'

const EditItem = ({ editKey }) => {
  const renderField = (config) => {
    const { field, type, label, placeholder, options } = config

    const fieldProps = {
      name: field,
      className: "border-grey",
      placeholder: placeholder || ''
    }

    let fieldElement

    switch (type) {
      case 'select':
        fieldElement = (
          <Field {...fieldProps} as="select">
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Field>
        )
        break
      case 'postcode':
        fieldElement = (
          <Field name={field}>
            {({ field: formikField, form }) => (
              <Postcode
                response={formikField.value}
                setResponse={(postcodeData) => form.setFieldValue(field, postcodeData)}
                settings={{allCountries: true}}
                className="target-profile-page"
              />
            )}
          </Field>
        )
        break
      default:
        fieldElement = <Field {...fieldProps} type={type} />
    }

    return (
      <div key={field} className="edit-field">
        {label && <label className="bold margin-bottom half">{label}</label>}
        {fieldElement}
        <ErrorMessage
          name={field}
          component="span"
          className="error margin-top half"
        />
      </div>
    )
  }

  const fieldConfig = FIELD_CONFIGS[editKey] || []

  return (
    <div className="edit-item">
      <div className="edit-fields">
        {fieldConfig.map(config => renderField(config))}
      </div>
    </div>
  )
}

export default EditItem
